import { createSlice } from '@reduxjs/toolkit'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'
import { setLoader } from 'src/redux/loader'

const initialState = {
    total: 0,
    os: { android: 0, ios: 0, web: 0 },
    monthly: { labels: [], android: [], ios: [], web: [] },
}

const userStatsSlice = createSlice({
    name: "userStats",
    initialState,
    reducers: {
        setStats: (state, action) => {
            return { ...state, ...action.payload }
        }
    }
})

export const { setStats } = userStatsSlice.actions

export const getUserStats = () => {
    return async (dispatch) => {
        try {
            dispatch(setLoader(true))
            let res = await hit("/admins/users/stats", "get")
            if (!res?.err) {
                dispatch(setStats(res.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load user stats", severity: "error" }))
            }
        } catch (err) {
            dispatch(setToast({ show: true, message: "Failed to load user stats", severity: "error" }))
        } finally {
            dispatch(setLoader(false))
        }
    }
}

export default userStatsSlice.reducer
